// A tiny shared note: "which lights is the song playing right now showing?"
// The player (MiniPlayer.js) writes it; the TV on the About page (AboutTv.js) reads it, so the TV glows with the same colors, style and
// effect as the big player. Nothing here touches the server and nothing is stored.
//
// The note is either null (no song, or the lights do not apply) or
//   { off: true }                                  a member switched their lights off
//   { style, glow, fx, per, spin, rgb: [c0, c1, c2], beat, reach }
//        style  one of steady, pulse, heartbeat, maypole-cw, maypole-ccw
//        glow   30 to 100
//        fx     the effect name (frost, flames, ...) or null
//        per    seconds for one pulse / heartbeat;  spin  seconds for one round of a maypole
//        rgb    the three light colors as [r, g, b] (0 to 255)
//        beat   true when the lights are on Beat mode (the "boom"): the glow then follows the beats sent with publishBeat
//        reach  1 to 10, how far a blast of light travels (the "Strength" wedge)
let current = null;
const listeners = new Set();

export function publishLights(next) {
  current = next || null;
  listeners.forEach((fn) => {
    try { fn(current); } catch { /* a listener must never break the player */ }
  });
}

export function getLights() {
  return current;
}

export function subscribeLights(fn) {
  listeners.add(fn);
  return () => { listeners.delete(fn); };
}

// The About page's light bulb asks the player to open its Lights panel for the song that is playing. The player (MiniPlayer.js) answers
// with true when it opened the panel, false when it could not (no song is loaded, or the big player is already open).
let panelHandler = null;

export function onLightsPanelRequest(fn) {
  panelHandler = fn;
  return () => { if (panelHandler === fn) panelHandler = null; };
}

export function requestLightsPanel() {
  try { return panelHandler ? !!panelHandler() : false; } catch { return false; }
}

// The beat of the song that plays inside the TV's screen on the About page. The player listens to the sound (the big player is closed,
// so nothing else does) and sends one note per beat: how hard it hit, from 0.25 (soft) to 1 (as hard as the hardest lately).
// The TV answers with a flash of its glow and a blast of light that rushes out from its frame, like the big player's.
const beatListeners = new Set();

export function publishBeat(strength) {
  beatListeners.forEach((fn) => {
    try { fn(strength); } catch { /* a listener must never break the player */ }
  });
}

export function subscribeBeat(fn) {
  beatListeners.add(fn);
  return () => { beatListeners.delete(fn); };
}
